/*
  name : isPartOfElement 
  desc : check if click is outside elm
  params : elm => node / target => e.target
*/
export function isPartOfElement(elm, target) {
    return (
        target === elm ||
        elm.contains(target)
    );
}

/*
  name : replaceContent 
  desc : Replace html content
  params : html => data.html form ajax request / selector => selector to replace
*/
export function replaceContent(html, selector, oldContentWrapper) {
  const $root = document.createElement("div");
  $root.innerHTML = html;
 
  const newContentWrapper = $root.querySelector(selector);

  oldContentWrapper.replaceWith(newContentWrapper);
}


 /**
 * Vérifie si un élément est réellement visible à l'écran
 * @param {HTMLElement} el - L'élément à tester
 * @param {number} offset - marge en pixels
 * @returns {boolean}
 */
export function isVisible(el, offset = 0) {
    if (!el || !(el instanceof Element)) return false;

    // Taille > 0 ? 
    if (el.offsetWidth === 0 || el.offsetHeight === 0) return false;

    // Style > 0 ? 
    const style = window.getComputedStyle(el); 
    const isVisible = style.display !== 'none' &&
                      style.visibility !== 'hidden' &&
                      style.opacity !== '0';
 
    if (!isVisible) return false;  
 
    return true;
}
